import { BaseActionField } from 'schemaBuilder/types';

export function key({ schemaField }: BaseActionField): string {
  return schemaField.key || schemaField.provisionalKey;
}
